export const enum KinshipDegreeEnum {
  Spouse = 1,
  Child = 2,
  Grandchild = 3,
  Mother = 4,
  Father = 5,
  Stepmother = 6,
  Stepfather = 7,
  Grandmother = 8,
  Grandfather = 9,
  PersonAdoptingInsuredPerson = 10,
  Other = 11,
  EmergencyContact = 12,
}
